module.exports = __webpack_public_path__ + "img/logo.f1a878b1.png";